import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';

const UpdateUsernameModal = ({ visible, initialValue, onCancel, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            // 模拟接口调用
            console.log('正在修改账户名为:', values.username);
            // await updateUsernameApi(values.username);

            message.success('修改成功');
            onSuccess(values.username);
        } catch (error) {
            console.log('验证失败:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="修改账户名"
            open={visible}
            onCancel={onCancel}
            onOk={handleConfirm}
            confirmLoading={loading}
            width={400}
            okText="确定"
            cancelText="取消"
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{ username: initialValue }}
                style={{ marginTop: 20 }}
            >
                <Form.Item
                    name="username"
                    rules={[
                        { required: true, message: '请输入账户名' },
                        { max: 20, message: '账户名长度不能超过20个字符' }
                    ]}
                >
                    <Input
                        placeholder="账户名"
                        size="large"
                        allowClear
                        style={{ borderRadius: '6px' }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default UpdateUsernameModal;